module.exports = __webpack_public_path__ + "static/SHIB-331ba702971556629e2ac6507a312e4a.svg";